import { render, staticRenderFns } from "./FactsheetControls.vue?vue&type=template&id=070a7090"
import script from "./FactsheetControls.vue?vue&type=script&lang=js"
export * from "./FactsheetControls.vue?vue&type=script&lang=js"
import style0 from "./FactsheetControls.vue?vue&type=style&index=0&id=070a7090&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports